import Logo from '../../assets/images/sportplatzgarage.svg';
import { Link } from "react-router-dom";
import React from 'react';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

const TopBar = () => {
  return (
    <div className="top-bar">
      <div className="top-bar-logo-container">
        <Link to="/" className="top-bar-brand">
          <img className="top-bar-logo" src={Logo} alt="Sportplatzgarage" />
        </Link>
      </div>
      <div className="top-bar-label">Administration</div>
      <Link to="/admin/logout" className="top-bar-logout">
        <ExitToAppIcon fontSize="small" />
        <span>Abmelden</span>
      </Link>
    </div>
  );
};

export default TopBar;
